import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-multi-selection',
    templateUrl: './multi-selection.component.html',
    styleUrls: ['./multi-selection.component.scss'],
    standalone: false
})
export class MultiSelectionComponent implements OnInit {

  @Input() disabled: boolean = false
  @Input() set reset$(obs: Observable<any>) {
    obs.subscribe(() => {
      this.menuTrigger.closeMenu();
      this.deselectAll.emit()
    })
  }

  @Output() selectAll = new EventEmitter()
  @Output() deselectAll = new EventEmitter()
  @Output() invert = new EventEmitter()

  @ViewChild('menu') menu!: MatMenu
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger

  constructor() { }

  ngOnInit(): void {
  }

  onSelectAllClick(e: Event) {
    e.stopPropagation()
    this.menuTrigger.closeMenu()
    this.selectAll.emit()
  }

  onDeselectAllClick(e: Event) {
    e.stopPropagation()
    this.menuTrigger.closeMenu()
    this.deselectAll.emit()
  }

  onInvertClick(e: Event) {
    e.stopPropagation()
    this.menuTrigger.closeMenu()
    this.invert.emit()
  }

}
